<script>
import {useWishlistStore} from "../Stores/WishlistStore";
import WishlistTeaser from "./WishlistTeaser";
import _ from "../../Libraries/translations";

export default {
  name: "Wishlist",
  components: {
    WishlistTeaser
  },
  setup() {
    const wishlist = useWishlistStore();
    window.wishlist = wishlist;
    return {
      wishlist
    }
  },
  computed: {
    header() {
      return _('bookmarks');
    }
  }
}
</script>


<template>
  <transition :duration="200">
    <div class="wishlist-container" v-if="wishlist.visible">
      <div class="wishlist-bg"></div>
      <div class="wishlist">
        <a href="#" class="wishlist__close" @click.prevent="wishlist.hide">
          <i class="fa-thin fa-xmark"></i>
        </a>
        <div class="wishlist__header">
          {{ header }}
        </div>
        <div class="wishlist__list">
          <WishlistTeaser v-for="item in wishlist.items"
                          v-bind:key="item.key"
                          :id="item.id"
                          :type="item.type"
                          :title="item.title"
                          :price="item.price"
                          :category="item.category"
                          :image="item.image"
                          :url="item.url"/>
        </div>
      </div>
    </div>
  </transition>
</template>
